import type { DateFieldProps, DateFieldTypeConstraint } from '@bos/form';
import { DateField } from '@bos/form';
import type { FieldPathByValue, FieldValues } from 'react-hook-form';

export type AppBaseDateFieldProps<
	TFieldValues extends FieldValues,
	TFieldName extends FieldPathByValue<TFieldValues, DateFieldTypeConstraint>,
> = DateFieldProps<TFieldValues, TFieldName>;

/** Use AppText instead of AppBaseText, it should be used only within packages like mobility-ui */
export const AppBaseDateField = <
	TFieldValues extends FieldValues,
	TFieldName extends FieldPathByValue<TFieldValues, DateFieldTypeConstraint>,
>(
	props: AppBaseDateFieldProps<TFieldValues, TFieldName>,
) => <DateField {...props} />;
